import { createStore, applyMiddleware, Store, Middleware } from "redux";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";
import { RootState } from "./types";
import rootReducer from "./reducer";

import dealerSagas from "../features/Dealers/DealerSelect/state/sagas";
import enginedealerSagas from "../features/Dealers/state/sagas";
import menuSagas from "../features/Menu/state/sagas";
import connectByLabelSagas from "../features/Dealers/ConnectByLabel/state/sagas";
import dealerinfoSagas from "features/Dealers/Listings/Info/state/sagas";
import dealerLMConfigSagas from "../features/Dealers/Listings/Data/state/sagas";
import enginePreviewSagas from "../features/Dealers/Listings/GMBPreview/state/sagas"
import categoriesSagas from "../features/Dealers/Listings/Categories/state/sagas"
import operationHoursSagas from "../features/Dealers/Listings/OperationHours/state/sagas"
import specialHoursSagas from "../features/Dealers/Listings/SpecialHours/state/sagas"
import keywordsSagas from "../features/Dealers/Listings/Keywords/state/sagas"
import dealerLMImagesSagas from "../features/Dealers/Listings/Images/state/sagas"
import dealerLMDepartmentsSagas from "../features/Dealers/DealerConfiguration/Departments/state/sagas"
import securitySagas from "features/Security/state/sagas";
import publishSagas from "../features/Dealers/DealerConfiguration/Modals/ModalPush/state/sagas"
import listingSagas from "../features/Dealers/Listings/state/sagas"
import filtersSagas from "../features/Dealers/Performance/Filter/state/sagas";
import insightsSagas from "../features/Dealers/Performance/state/sagas"
import completenessSagas from "../features/Dealers/Performance/Widgets/ProfileCompleteness/state/sagas";
import urlUpgradeSagas from "../features/Home/Modals/UpsellUpgrade/state/sagas";
import urlUpgradePackageSagas from "../features/Home/Modals/UpsellUpgradePackage/state/sagas";
import urlSetupSagas from "../features/Home/Modals/UpsellSetup/state/sagas";
import getChatmeterSagas from '../features/Home/Modals/ModalStartElite/state/sagas'
import advancedLmSagas from "features/Dealers/AdvancedLm/state/sagas";
import reviewsSagas from "features/Dealers/Reviews/state/sagas";

const sagas = createSagaMiddleware();
const middleware: [Middleware] = [sagas];

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    //middleware.push(logger);
}

const store: Store<RootState> = createStore(
    rootReducer,
    applyMiddleware(...middleware)
);

sagas.run(dealerSagas);
sagas.run(enginedealerSagas)
sagas.run(menuSagas)
sagas.run(connectByLabelSagas)
sagas.run(dealerinfoSagas)
sagas.run(dealerLMConfigSagas)
sagas.run(enginePreviewSagas)
sagas.run(categoriesSagas)
sagas.run(specialHoursSagas)
sagas.run(operationHoursSagas)
sagas.run(keywordsSagas)
sagas.run(dealerLMImagesSagas)
sagas.run(dealerLMDepartmentsSagas)
sagas.run(securitySagas);
sagas.run(publishSagas);
sagas.run(listingSagas);
sagas.run(filtersSagas);
sagas.run(insightsSagas);
sagas.run(completenessSagas);
sagas.run(urlUpgradeSagas);
sagas.run(urlUpgradePackageSagas);
sagas.run(urlSetupSagas);
sagas.run(getChatmeterSagas);
sagas.run(advancedLmSagas);
sagas.run(reviewsSagas);

export default store;
